import React, { useState, useEffect } from 'react';
import { Tab, Tabs, AppBar } from '@mui/material';
import RegistrationReport from '../apps/reports/registration';
import { useSelector, useDispatch } from "react-redux";
import { getAllInquiries, getAllInquiryTypes } from "../actions/inquiries";
import ProfileReport from '../apps/reports/profileCreation';
import ProfileCreationReport from '../apps/reports/profileCreatedBy';
import DesignationReport from '../apps/reports/designationReport'; // Import the new report
import DesignationReportTable from '../apps/reports/designationReportTable'
import CvReport from '../apps/reports/cvReport'

const TabPanel = ({ value, index, children }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && (
        <div>
          {children}
        </div>
      )}
    </div>
  );
};

function Reports() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dispatch = useDispatch();
  const inquiryList = useSelector((state) => state.inquiryList);
  const inquiryTypeList = useSelector((state) => state.inquiryTypeList);

  const { loading: isDataLoaded, inquiries } = inquiryList;
  const { loading: isDataLoaded2, inquiryTypes } = inquiryTypeList;

  const [formInfo, setFormInfo] = useState({
    inqueries: [],
    filteredInqueries: [],
  });

  const DummyData = [
    {
      label: 'Registration Report',
      content: <RegistrationReport inquiries={inquiryList} />,
    },
    {
      label: 'Profile Creation Count By Employee',
      content: <ProfileReport />,
    },
    {
      label: 'Profile Created By',
      content: <ProfileCreationReport />,
    },
    {
      label: 'Designation Report',
      content: <DesignationReport />, // Replace 'designationData' with your actual data source
    },
    {
      label: 'Designation Report Table',
      content: <DesignationReportTable/>
    },
    {
      label: 'CV Report',
      content: <CvReport/>
    }
  ];

  useEffect(() => {
    if (!isDataLoaded) {
      dispatch(getAllInquiries());
    }
    if (!isDataLoaded2) {
      dispatch(getAllInquiryTypes());
    }
  }, []);

  useEffect(() => {
    console.log("inquiries", inquiryList.inquiries);
  }, [inquiryList]);

  return (
    <div>
      <AppBar style={{ background: 'white' }} position="static">
        <Tabs value={value} onChange={handleChange} centered>
          {DummyData.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      </AppBar>
      {DummyData.map((tab, index) => (
        <TabPanel key={index} value={value} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </div>
  );
}

export default Reports;
